/*
 * umbra-gallery-wheel.js (STAGE 6, 2026-09-08; transition, side rails and thumb reveal added 2026-09-09;
 * three screen tiers and the phone transition added 2026-09-09 evening)
 *
 * Mete: "an option to slide left-right the product images ... a carousel effect when scrolled, infinite,
 * one scroll = one image like the home deck but horizontal within the product image. Only when scrolled
 * up or down, only over the image on the left; over the product info the page scrolls normally."
 *
 * Loaded by sections/main-product.liquid while its gallery_wheel setting is on, or while the phone
 * transition (gallery_fx_mobile) is on, with defer. The wheel gesture itself is desktop-only (min-width
 * 770px, the smaller and larger tiers): the phone keeps the theme's own slider, swipe and dots.
 *
 * The listener sits on #product-media, so a wheel over the info column never reaches it and the page
 * scrolls as usual. Over the photo the gesture is taken over and, with the home deck's accumulator
 * (threshold 40, reset on a direction change or after 170ms of silence, one advance per gesture: see "One gesture,
 * one image" below), the theme's slider moves one image forward or back and
 * loops at both ends. Where the theme's prev / next arrow exists and is enabled it is clicked, so the
 * theme's own handler does the move; when there is no arrow or it refuses (the ends), the viewer is
 * scrolled to the target slide directly and the theme's scroll handler updates the thumbnails, counter
 * and arrows. Reduced motion jumps instead of gliding. The lightbox is appended to document.body and is
 * never touched.
 *
 * 2026-09-09, Mete: "a cool transition when it changes the images from one to another since this is a
 * carousel ... a toggle for adding/removing transition", and the thumbnails centred under the photo or on
 * a left / right rail. The section prints <script type="application/json" data-umbra-wheel-config> with
 * {fx, style, ms, rail} for the smaller screens, plus wheel (the wheel setting), lgMin (where the larger
 * screens start), lg {fx, style, ms, rail, fill} for the larger screens (already resolved: "same as
 * smaller screens" arrives as the smaller value) and m {fx, style, ms, layout} for the phone. It is read
 * once. ?umbra_fx=fade|slide|zoom|none in the URL overrides fx / style for previews on whichever tier is
 * active (the length stays the theme's for that tier).
 *
 * Tiers, Mete: "smaller screen / larger screen / mobile are all different remember please". side() is
 * 'phone' (under 770px), 'small' (770px up to lgMin) or 'large' (lgMin and up), read live from two
 * matchMedia lists, and fx() is that side's {on, style, ms}. With fx on for the active side,
 * #product-media carries data-umbra-fx="<style>" and --umbra-fx-ms, and a wheel notch, a thumbnail
 * click, an arrow click or a phone dot tap (capture-phase listeners, so the theme's own handlers run
 * against an already-moved slider) go through go(): a clone of the outgoing .media is dropped over the
 * viewer as .umbra-fx-ghost, the slider jumps instantly to the target (the theme's scroll handler still
 * updates thumbnails, counter and arrows), the incoming item gets .umbra-fx-in, and the section's CSS
 * animates the ghost out and the new image in (--umbra-fx-dir carries the direction for the slide
 * style). The ghost is removed on animationend with a setTimeout backstop. A colour swatch change
 * (on:variant:change, taken in the capture phase BEFORE the theme's media grouping hides the outgoing
 * item) gets the ghost only: the theme does its own instant jump, this script never writes scrollLeft
 * there. A finger swipe stays the native scroll. Reduced motion and non-image slides get no ghost: the
 * slider jumps or glides as before. revealThumb() keeps the active thumbnail in view when the thumbnails
 * are a vertical rail that overflows (rail only, never the window); a wheel over a rail or strip that
 * can scroll is left to it. When the phone preview override asks for a transition the section did not
 * emit CSS for (gallery_fx_mobile off), the phone rules are injected here so the preview still shows it.
 *
 * Round 2 arrows (2026-09-09 evening), Mete: "add it as a toggle on the settings and also add options of how it
 * would look". advance() is exposed as #product-media.umbraAdvance(dir); the edge-glow / cursor zones printed by
 * snippets/media-gallery.liquid page through it (loop, transition), #product-media carries data-umbra-cur-type
 * (the current slide's media type, so the section's CSS hides the zones over a video or a 3D model) and the
 * cursor look's progress hairline gets --umbra-n / --umbra-i, both refreshed 100ms after the viewer settles.
 * ?umbra_arrows=classic|edge-glow|cursor|pill overwrites the data-umbra-arrows(-lg) stamps the section printed
 * from its settings, for previews. The section loads this script for those two looks even with the wheel and
 * the phone transition off ("wheel": false keeps the wheel listener off).
 *
 * Finish (2026-09-10): #product-media is guarded by data-umbra-init and carries data-umbra-wheel only while the
 * wheel is on (the section's CSS hides the zones at the ends through :not([data-umbra-wheel]) when the wheel is
 * off); the matchMedia / document / window listeners a setup registers are kept on the element as
 * umbraTeardown() and removed on shopify:section:unload.
 *
 * Lulu filmstrip (2026-09-10), Mete: "as the screen gets wider more images sit side by side ... a wheel notch moves
 * the strip one image". The section lays N square slots side by side (gallery_strip / gallery_strip_lg) and the
 * config carries strip {mode, min, peek, gap} per tier ("strip" for the smaller screens, lg.strip for the larger;
 * absent while the strip is off everywhere). Nothing here moves differently: the theme's media-gallery.js already
 * steps by one slot (its offset is slide + margin) and advance() already scrolls smoothly, so one notch = one slot.
 * Three additions: fitStrip() writes --strip-auto-n on #product-media for an 'auto' tier (the most slots of at least
 * min px that fit the pane, re-fitted on resize and on a tier change, then the theme is poked to re-measure);
 * advance() treats "cannot scroll further" as the end of the strip (with N slots the last index is never the scroll
 * position) and loops from there; and the next arrow is disabled at that end 120ms after the strip settles (the theme
 * disables it only on the last index). fx() reports the transition off for a strip tier, ?umbra_fx= included: the
 * ghost covers the whole viewer and would flash across every slot.
 *
 * Flip + seamless loop (2026-09-11), Mete: "when scrolled to the next image, the previous image's peek appears
 * on the left and the new image loads fully on the right ... the first scroll is a smaller scroll ... infinite
 * carousel, never resets back". With V the viewer width, S the slot, G the gap and P = V - S - G the peek:
 * state 0 (page load) is scrollLeft 0, [ full item0 : S ][ G ][ peek item1 : P ]; state t >= 1 has the right edge
 * of item t flush with the viewer's right edge, [ peek item t-1 : P ][ G ][ full item t : S ]. So the first
 * forward step is S - P and every later one is S + G, and backward is the exact inverse (state 1 back to state 0
 * restores the load composition). Every position is read from the live DOM, never accumulated, so a resize or a
 * sub-pixel slot cannot drift; the section prints scroll-snap-align: end on the slots of a flipped band, which
 * makes each of those positions a real snap point, so a drag, a trackpad swipe and the browser's own re-snap
 * after a resize land on exactly the grid this script uses. The infinite loop appends three clones of the
 * leading items after the last one (track index n + j = item j mod n): forward walks into them and, the moment
 * the viewer has ARRIVED at t = n + 1 (peek of clone 0, full clone 1 - pixel-identical to t = 1), one set width
 * is subtracted from scrollLeft and t drops by n, so the jump is never seen; backward from state 0 is the
 * mirror, scrollLeft jumps silently to the flush-LEFT of clone 0 (again identical to state 0) and the step then
 * runs from there onto the real last image. The resting set is t in [0, n]; only t = n sits on a clone (the
 * first image in the flipped composition, which has no real position). Clones carry no .media-viewer__item
 * class, so the theme's setVisibleItems, counter and currentIndex never see one; they keep data-media-id, so a
 * click opens the lightbox on the ORIGINAL image (gallery-zoom.js reads it off the li); they are aria-hidden
 * with every focusable inside taken out of the tab order; and they are rebuilt on a resize and on a colour
 * change (dropped in the capture phase, before the theme hides the outgoing group). The theme's handleScroll
 * divides scrollLeft by its slot offset, which both the flipped positions and the clones break, so
 * customSetActiveMedia is shadowed on the gallery instance while the flip is on and resolves the index from t.
 * Ask 1 of the same round: --umbra-gap-bg is measured off the details column at runtime, so the ground between
 * and around the slots can take the buy column's colour without touching the packshots' own --blend-bg-color.
 *
 * Fix round 1 (2026-09-09): the section's fill CSS ("First image fills the screen") sizes the media
 * column from the header's bottom edge. The OVO header republishes --header-end 31px smaller once the
 * utility bar scrolls away (99 -> 68 at 1440x900), and a cap that read it live widened the media column
 * and re-wrapped the info column on every scroll. freezeHeaderEnd() publishes --umbra-header-end on
 * :root = --header-end taken at the top of the page, refreshed only when the header republishes while
 * the page is at the top (load, fonts, resize, its own transitionend), never while scrolled; the CSS
 * reads var(--umbra-header-end, var(--header-end, 99px)). Review fix (2026-09-09): every write is
 * followed by a synthetic on:debounced-resize on window, so the theme's media-gallery re-measures its
 * slide offset (its scroll handler ignores moves while that stored offset is stale).
 *
 * One gesture, one image (R1102, 2026-11-02), Mete: "make sure it is not going crazy when the user scrolls fast. it is
 * trying to pass multiple at once". The accumulator above re-armed on any notch 40ms after the last one or on a rising
 * delta, so a fast mouse spin (Windows sends a 100 notch every ~50ms) stepped once per notch and a trackpad's jittery
 * momentum stepped 3-4 times, each step starting from wherever the glide or crossfade before it had got to. Now a
 * gesture ends only after QUIET_MS (170ms) of wheel silence: after a step the rest of that gesture is swallowed (still
 * prevented, so the page does not creep), a new gesture or a turn of direction counts again, and small trackpad
 * deltas still add up to SENS before a step. A step that comes while the previous one is still on screen (its
 * crossfade, fx ms; or its glide, until the viewer has not scrolled for 90ms) waits for it and then runs, one at most,
 * so deliberate notches 400ms apart still move one image each. Arrows, keyboard, thumbnails, the loop at the ends and
 * the phone are unchanged.
 *
 * Ends release the page (R1103, 2026-11-03), Mete, board 16 q3-galleryend: "At the last photo, scroll the page". While
 * the theme setting umbra_gallery_wheel_release_ends is on (snippets/media-gallery.liquid stamps
 * data-umbra-wheel-ends="release" on <media-gallery>; off prints nothing and the wheel loops as before), a wheel gesture
 * that starts on the last photo going down, or on the first photo going up, is not taken: the page scrolls, and the rest
 * of that gesture keeps going to the page. A gesture that steps onto the last photo still ends there (its tail is
 * swallowed as above); the next gesture scrolls the page. A queued step that would wrap is dropped. Arrows, keyboard,
 * swipe, dots and thumbnails keep looping ("infinite", Mete 2026-09).
 */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 770px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SENS = 40;
  /* R1102 (Mete, 2 Nov: a fast scroll "is trying to pass multiple at once"): one gesture = one image.
     QUIET_MS of wheel silence ends a gesture (a mouse spin, a flick or a trackpad momentum tail are each one
     gesture); MOVE_MIN_MS is how long a smooth move counts as running before its first scroll event lands. */
  var QUIET_MS = 170;
  var MOVE_MIN_MS = 160;
  var SCROLL_IDLE_MS = 90;
  var STYLES = ['fade', 'slide', 'zoom'];
  var ARROWS = ['classic', 'edge-glow', 'cursor', 'pill'];

  var cfgEl = document.querySelector('script[data-umbra-wheel-config]');
  var cfg = { fx: false, style: 'fade', ms: 500, rail: 'bottom', wheel: true, lgMin: 1441, lg: null, m: null };
  try {
    if (cfgEl) {
      var raw = JSON.parse(cfgEl.textContent);
      for (var key in raw) {
        if (Object.prototype.hasOwnProperty.call(raw, key)) cfg[key] = raw[key];
      }
    }
  } catch (e) {}
  cfg.ms = parseInt(cfg.ms, 10) || 500;
  var lgMin = parseInt(cfg.lgMin, 10) || 1441;
  var mqLg = window.matchMedia('(min-width: ' + lgMin + 'px)');
  var qp = null;
  try { qp = new URLSearchParams(location.search).get('umbra_fx'); } catch (e) {}
  var qa = null;
  try { qa = new URLSearchParams(location.search).get('umbra_arrows'); } catch (e) {}

  /* one {on, style, ms} per tier, the URL override applied to each so it previews whichever tier is active */
  function tier(base, msDefault) {
    var t = { on: !!base.fx && STYLES.indexOf(base.style) >= 0, style: base.style, ms: parseInt(base.ms, 10) || msDefault };
    if (qp === 'none') {
      t.on = false;
    } else if (STYLES.indexOf(qp) >= 0) {
      t.on = true;
      t.style = qp;
    }
    return t;
  }
  var tiers = {
    small: tier(cfg, 500),
    large: tier(cfg.lg || cfg, 500),
    phone: tier(cfg.m || { fx: false, style: 'fade', ms: 350 }, 350)
  };
  function side() {
    return mqLg.matches ? 'large' : (mq.matches ? 'small' : 'phone');
  }
  function fx() {
    var t = tiers[side()];
    if (stripActive()) return { on: false, style: t.style, ms: t.ms };
    return t;
  }
  var fxSeq = 0;

  /* --umbra-header-end: --header-end frozen at its page-top value (see the header comment). Taken once at
     init, then again on every :root inline-style change (the header and the utility bar publish there)
     while the page is at the top; a page restored mid-scroll takes the collapsed value and corrects
     itself the first time it is back at the top. Only a changed value is written, so its own write never loops. */
  var headerEndPx = 0;
  var headerEndObserved = false;
  /* the theme's media-gallery re-measures its slide offset only on the window's on:debounced-resize (see freezeHeaderEnd) */
  function pokeGallery() {
    try {
      window.dispatchEvent(new CustomEvent('on:debounced-resize'));
    } catch (e) {
      var ev = document.createEvent('Event');
      ev.initEvent('on:debounced-resize', false, false);
      window.dispatchEvent(ev);
    }
  }
  function freezeHeaderEnd() {
    if (window.pageYOffset > 1 && headerEndPx) return;
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-end')) || 0;
    if (!v || v === headerEndPx) return;
    headerEndPx = v;
    document.documentElement.style.setProperty('--umbra-header-end', v + 'px');
    /* That write just changed the width of the media column and of every slide (the section's fill cap
       reads --umbra-header-end). The theme's media-gallery stores the slide-to-slide offset once in
       initGallery and refreshes it only in handleResize, which listens solely for the window's
       on:debounced-resize (assets/main.js dispatches it after a real resize); its handleScroll skips
       customSetActiveMedia while the live offset differs from the stored one, so without this the
       thumbnails, counter and arrows stopped following the wheel after any post-init republish (a page
       restored mid-scroll, then brought back to the top). handleResize reads offsetLeft synchronously,
       so the event goes out straight away. */
    pokeGallery();
  }
  function watchHeaderEnd() {
    freezeHeaderEnd();
    if (headerEndObserved || !('MutationObserver' in window)) return;
    headerEndObserved = true;
    new MutationObserver(freezeHeaderEnd).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', freezeHeaderEnd);
  }

  /* Lulu filmstrip: the active tier's {mode, min, peek, gap}, null on the phone or while the strip is off everywhere */
  function stripCfg() {
    var s = side();
    if (s === 'phone') return null;
    if (s === 'large' && cfg.lg && cfg.lg.strip) return cfg.lg.strip;
    return cfg.strip || null;
  }
  /* the slot count 'as many as fit' last resolved for the active tier (1 until fitStrip has measured) */
  var autoN = 1;
  /* 'full' has no slot count to fall back on: its slot is the height budget and the next image shows in
     whatever width the pane has left. FULL_MIN_PEEK is how much of that next image has to show for the band
     to count as a strip; under it (a tall window on a 1441-1576 screen, where the pane is narrower than the
     height budget) there is no second image at all and the page is today's, so the thumbnails, the crossfade,
     the fill cap and the merchant's arrows stay - the same rule 'as many as fit' follows when one slot fits. */
  var FULL_MIN_PEEK = 24;
  var fullFits = true;
  /* ACTIVE = the strip really is showing two or more images. An 'as many as fit' band that only fits ONE slot is not
     a strip at all: the thumbnails, the crossfade, the fill cap and the merchant's arrows all come back, because the
     section gates every strip rule on data-umbra-strip and fitStrip takes that attribute off again. */
  function stripActive() {
    var s = stripCfg();
    if (!s || s.mode === 'off') return false;
    if (s.mode === 'auto') return autoN >= 2;
    if (s.mode === 'full') return fullFits;
    return true;
  }
  /* 'auto': the most slots of at least min px (gap between, peek of the next one showing) that fit the pane; written
     as --strip-auto-n on #product-media (the section's CSS reads it, 1 until then; the section's inline bootstrap
     wrote the first value before the first paint with the same formula). The pane is measured WITH data-umbra-strip
     set, because that attribute is what gives the media column the strip's own width; the flag comes back off when
     only one slot fits. Returns true when the flag changed, so the caller can re-stamp fx and the arrows and let the
     theme re-measure its slot offset. */
  function fitStrip(media, viewer) {
    var s = stripCfg();
    var was = media.hasAttribute('data-umbra-strip');
    var on = !!s && s.mode !== 'off';
    if (on) media.setAttribute('data-umbra-strip', 'on');
    if (on && s.mode === 'auto') {
      var min = parseInt(s.min, 10) || 480;
      var gap = parseInt(s.gap, 10) || 0;
      var peek = parseInt(s.peek, 10) || 0;
      var n = Math.max(1, Math.floor((viewer.clientWidth - peek + gap) / (min + gap)));
      autoN = n;
      if (media.style.getPropertyValue('--strip-auto-n') !== String(n)) media.style.setProperty('--strip-auto-n', String(n));
      on = n >= 2;
    }
    if (on && s.mode === 'full') {
      /* measured with data-umbra-strip already stamped, so the slot and the pane are the strip's own */
      var fitems = viewer.querySelectorAll('.media-viewer__item');
      var slot = 0;
      for (var fi = 0; fi < fitems.length; fi++) {
        var fwid = fitems[fi].getBoundingClientRect().width;
        if (fwid > 0) { slot = fwid; break; }
      }
      var fgap = parseInt(s.gap, 10) || 0;
      fullFits = slot > 0 && viewer.clientWidth - slot - fgap >= FULL_MIN_PEEK;
      on = fullFits;
    }
    if (!on) media.removeAttribute('data-umbra-strip');
    return on !== was;
  }

  /* preview aid only: the section emits the phone ghost rules while gallery_fx_mobile is on; with it off and
     ?umbra_fx= asking for one anyway, the same rules are injected once so the preview shows the transition */
  var phoneCssInjected = false;
  function ensurePhoneCss() {
    if (phoneCssInjected || (cfg.m && cfg.m.fx)) return;
    phoneCssInjected = true;
    var s = document.createElement('style');
    s.setAttribute('data-umbra-fx-preview', 'phone');
    s.textContent = '@media (max-width: 769.98px) {' +
      '#product-media { --umbra-fx-ease: cubic-bezier(.22, .61, .36, 1); }' +
      '#product-media[data-umbra-fx="fade"], #product-media[data-umbra-fx="zoom"] { --umbra-fx-ease: cubic-bezier(.45, 0, .55, 1); }' +
      '#product-media .media-gallery__viewer > .pdp-mdots { z-index: 5; }' +
      '#product-media .umbra-fx-ghost { position: absolute; inset: 0; z-index: 4; overflow: hidden; pointer-events: none; background-color: var(--gallery-bg-color); animation: umbra-fx-out-fade var(--umbra-fx-ms) var(--umbra-fx-ease) forwards; }' +
      '#product-media .umbra-fx-ghost > .media { width: 100%; }' +
      '#product-media .media-viewer__item.umbra-fx-in .media { animation: umbra-fx-in-fade var(--umbra-fx-ms) var(--umbra-fx-ease) both; }' +
      '#product-media[data-umbra-fx="slide"] .umbra-fx-ghost { animation-name: umbra-fx-out-slide; }' +
      '#product-media[data-umbra-fx="slide"] .media-viewer__item.umbra-fx-in .media { animation-name: umbra-fx-in-slide; }' +
      '#product-media[data-umbra-fx="zoom"] .umbra-fx-ghost { animation-name: umbra-fx-out-zoom; }' +
      '#product-media[data-umbra-fx="zoom"] .media-viewer__item.umbra-fx-in .media { animation-name: umbra-fx-in-zoom; }' +
      '}';
    document.head.appendChild(s);
  }

  function setup(media) {
    if (media.dataset.umbraInit) return;
    media.dataset.umbraInit = 'on';
    if (cfg.wheel) media.dataset.umbraWheel = 'on';
    var viewer = media.querySelector('.media-viewer');
    if (!viewer) return;
    /* listeners outside the element (matchMedia, document, window) are recorded so the editor's section:unload can drop them */
    var offs = [];
    function listen(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      offs.push(function () { target.removeEventListener(type, fn, opts); });
    }
    media.umbraTeardown = function () {
      for (var i = 0; i < offs.length; i++) offs[i]();
      offs = [];
      delete media.umbraTeardown;
    };
    var accum = 0, accumDir = 0;
    var lastAt = -1e9, locked = false, lockDir = 0;
    var stepEnd = 0, lastScrollAt = -1e9, pendingDir = 0, pendingT = 0;
    /* R1103 q3-galleryend: release the page at the ends (wheel only) */
    var releasing = false, releaseDir = 0, lastTarget = -1;
    function relEnds() {
      return !!(media.querySelector('[data-umbra-wheel-ends="release"]') || media.closest('[data-umbra-wheel-ends="release"]'));
    }

    /* the CSS keys the style off data-umbra-fx; stamped for whichever tier is active, re-stamped when the tier changes */
    function applyFx() {
      var t = fx();
      if (t.on) {
        media.setAttribute('data-umbra-fx', t.style);
        media.style.setProperty('--umbra-fx-ms', t.ms + 'ms');
        if (side() === 'phone') ensurePhoneCss();
      } else {
        media.removeAttribute('data-umbra-fx');
        media.style.removeProperty('--umbra-fx-ms');
      }
    }
    applyFx();
    /* the corner pill while the strip is active, the merchant's own look the moment it is not: the section stamps the
       configured value on data-umbra-arrows[-lg] and the inline bootstrap copies it into ...-cfg before switching to
       the pill, so the look survives a resize out of the strip tier. A ?umbra_arrows= preview overrides everything. */
    var ARROW_ATTRS = ['data-umbra-arrows', 'data-umbra-arrows-lg'];
    function applyArrows() {
      if (!cfg.strip && !(cfg.lg && cfg.lg.strip)) return;
      if (ARROWS.indexOf(qa) >= 0) return;
      var on = stripActive();
      for (var i = 0; i < ARROW_ATTRS.length; i++) {
        var a = ARROW_ATTRS[i];
        var stash = a + '-cfg';
        if (!media.hasAttribute(a) && !media.hasAttribute(stash)) continue;
        if (on) {
          if (!media.hasAttribute(stash)) media.setAttribute(stash, media.getAttribute(a) || '');
          if (media.getAttribute(a) !== 'pill') media.setAttribute(a, 'pill');
        } else if (media.hasAttribute(stash)) {
          var was = media.getAttribute(stash);
          if (!was) media.removeAttribute(a);
          else if (media.getAttribute(a) !== was) media.setAttribute(a, was);
        }
      }
    }
    [mq, mqLg].forEach(function (list) {
      if (list.addEventListener) {
        listen(list, 'change', applyFx);
      } else if (list.addListener) {
        list.addListener(applyFx);
        offs.push(function () { list.removeListener(applyFx); });
      }
    });

    function visible() {
      return Array.prototype.filter.call(viewer.querySelectorAll('.media-viewer__item'), function (it) {
        return it.clientWidth > 0;
      });
    }

    /* ---------------------------------------------------------------------------------------------
       Lulu flip + seamless loop (2026-09-11). Geometry, the clone contract and the reason the theme's
       own index bookkeeping has to be shadowed: see the header comment. Everything below is inert
       unless the active tier's strip config carries flip (and, for the clones, loop).
    --------------------------------------------------------------------------------------------- */
    var CLONE_N = 3;
    var flipT = 0;            /* track index of the image shown in full */
    var flipLeft = true;      /* true only at t = 0, where that image is flush LEFT (the load state) */
    var flipClones = [];
    var cloneKey = '';
    var flipIdle = 0;
    var flipWrapT = 0;
    var flipWrapTries = 0;
    var flipExternal = 0;     /* 1 while a colour change is in flight: the theme's own pick is honoured then */
    var csamOrig = null;

    function gallery() { return media.querySelector('media-gallery'); }
    function flipCfgOn() { var s = stripCfg(); return !!(s && s.flip); }
    function loopOn() { var s = stripCfg(); return !!(s && s.flip && s.loop); }
    function flipOn() { return flipCfgOn() && stripActive() && visible().length > 1; }
    function trackItems() { return visible().concat(flipClones); }
    /* scroll coordinates straight off the live boxes: scrollLeft + (box - viewport) is invariant under scrolling */
    function flushLeft(el) { return viewer.scrollLeft + el.getBoundingClientRect().left - viewer.getBoundingClientRect().left; }
    function flushRight(el) { return flushLeft(el) + el.getBoundingClientRect().width - viewer.clientWidth; }
    function flipPos(t, left, track) {
      var el = track[t];
      if (!el) return null;
      return left ? flushLeft(el) : flushRight(el);
    }
    function setWidth() {
      var vis = visible();
      if (!flipClones.length || !vis.length) return 0;
      return flushLeft(flipClones[0]) - flushLeft(vis[0]);
    }
    function flipIndex(n) {
      if (!n) return 0;
      var i = flipT % n;
      return i < 0 ? i + n : i;
    }
    function scrollNow(x) {
      var sb = viewer.style.scrollBehavior;
      viewer.style.scrollBehavior = 'auto';
      viewer.scrollLeft = x < 0 ? 0 : x;
      viewer.style.scrollBehavior = sb;
    }
    /* The band's slots are scroll-snap-align: end, which is what makes every flip position a real snap point
       for a finger or a trackpad. A programmatic move is a different matter: the silent jump onto the flush-LEFT
       of a clone is deliberately NOT a snap point, and mandatory snapping pulled it 281px onto the clone's own
       end alignment (measured at 1920), which is exactly the jump this mechanism exists to hide. So snapping is
       off for the duration of a programmatic move and back on the moment the viewer has arrived - the arrival
       position is a snap point, so restoring it moves nothing. */
    function snapSet(off) {
      if (off) {
        if (viewer.style.scrollSnapType !== 'none') viewer.style.scrollSnapType = 'none';
      } else if (viewer.style.scrollSnapType) {
        viewer.style.removeProperty('scroll-snap-type');
      }
    }

    function clearClones() {
      for (var i = 0; i < flipClones.length; i++) {
        if (flipClones[i].parentNode) flipClones[i].parentNode.removeChild(flipClones[i]);
      }
      flipClones = [];
    }
    function buildClones() {
      clearClones();
      if (!loopOn() || !stripActive()) return;
      var vis = visible();
      if (vis.length < 2) return;
      for (var i = 0; i < CLONE_N; i++) {
        /* every .media-viewer__item* class is dropped: the theme's setVisibleItems, the counter total and the
           --variant hide rule all key off them, and a clone has to be invisible to all three. data-media-id
           stays, so gallery-zoom.js opens the ORIGINAL image from a click on a clone. */
        var c = vis[i % vis.length].cloneNode(true);
        c.className = 'umbra-strip-clone';
        /* --slot-ar reaches a real slot through an :nth-child rule, which a clone no longer matches: carry it inline */
        var srcAr = getComputedStyle(vis[i % vis.length]).getPropertyValue('--slot-ar');
        if (srcAr && srcAr.trim()) c.style.setProperty('--slot-ar', srcAr.trim());
        c.style.display = '';
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-umbra-clone', String(i));
        var f = c.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        for (var j = 0; j < f.length; j++) f[j].setAttribute('tabindex', '-1');
        viewer.appendChild(c);
        flipClones.push(c);
      }
    }

    /* the counter, the active thumbnail and the arrows stay the theme's; they are fed the ORIGINAL item for t */
    function syncGallery() {
      var mg = gallery();
      if (!mg || typeof mg.customSetActiveMedia !== 'function') return;
      var list = mg.visibleItems || [];
      var it = list[flipIndex(list.length)];
      if (it) mg.customSetActiveMedia(it, false);
    }
    function patchGallery() {
      var mg = gallery();
      if (!mg || csamOrig || typeof mg.customSetActiveMedia !== 'function') return;
      csamOrig = mg.customSetActiveMedia;
      mg.customSetActiveMedia = function (item, scrollToItem) {
        if (!flipOn()) return csamOrig.call(this, item, scrollToItem);
        var list = this.visibleItems || [];
        var it = flipExternal && item && list.indexOf(item) >= 0 ? item : list[flipIndex(list.length)];
        if (!it) return undefined;
        /* never the theme's own scrollTo: it is start-aligned and would undo the flip composition */
        return csamOrig.call(this, it, false);
      };
      offs.push(function () { if (csamOrig) { delete mg.customSetActiveMedia; csamOrig = null; } });
    }

    /* The seamless step. The viewer is put on the position one set width back, which renders the identical
       picture, and t drops by n. It runs 70ms after the viewer has gone quiet (flipSettle) and not the instant
       scrollLeft is near the target: fired early it would subtract from a position the smooth scroll had not
       reached yet, land off the snap grid and let the browser re-snap it, which moved the picture 4px in one
       frame (measured on a per-frame trace at 1920 and 2560). Scrolling to the exact destination instead lands
       on a real snap point, so nothing moves. */
    function flipWrap() {
      var n = visible().length;
      if (!n || !flipClones.length || flipT < n + 1) return false;
      var t = flipT;
      while (t >= n + 1) t -= n;
      var target = flipPos(t, false, trackItems());
      if (target === null) return false;
      scrollNow(target);
      flipT = t;
      flipLeft = false;
      return true;
    }
    /* a native gesture (trackpad on X, a drag) lands on one of the same snap points: take the state back from it */
    function flipResync() {
      if (!flipOn()) return;
      var track = trackItems();
      var best = -1, bestD = Infinity, p, d;
      for (var t = 0; t < track.length; t++) {
        p = t === 0 ? flushLeft(track[0]) : flushRight(track[t]);
        d = Math.abs(viewer.scrollLeft - p);
        if (d < bestD) { bestD = d; best = t; }
      }
      if (best < 0 || bestD > 12) return;
      flipT = best;
      flipLeft = best === 0;
      if (bestD > 0.5) scrollNow(best === 0 ? flushLeft(track[0]) : flushRight(track[best]));
      flipWrap();
      snapSet(false);
      syncGallery();
    }
    /* the wrap only ever runs from the exact target, or the set width it subtracts is taken from a position the
       smooth scroll has not reached yet and the picture jumps by the remainder (measured 146px at 2560x1440) */
    function flipWrapTry() {
      var n = visible().length;
      if (!flipOn() || flipT < n + 1) return;
      var want = flipPos(flipT, false, trackItems());
      if (want !== null && Math.abs(viewer.scrollLeft - want) > 1) {
        if (flipWrapTries < 12) {
          flipWrapTries++;
          flipWrapT = setTimeout(flipWrapTry, 90);
          return;
        }
        scrollNow(want);
      }
      flipWrapTries = 0;
      flipWrap();
      snapSet(false);
    }
    function flipSettle() {
      if (!flipOn()) return;
      clearTimeout(flipIdle);
      if (flipT >= visible().length + 1) {
        clearTimeout(flipWrapT);
        flipWrapT = setTimeout(flipWrapTry, 90);
        return;
      }
      var want = flipPos(flipT, flipLeft, trackItems());
      if (want !== null && Math.abs(viewer.scrollLeft - want) <= 2) { snapSet(false); return; }
      flipIdle = setTimeout(flipResync, 220);
    }

    function flipStep(dir) {
      var vis = visible();
      var n = vis.length;
      if (n < 2) return false;
      var loop = flipClones.length >= CLONE_N;
      var t = flipT, left = flipLeft, jump = 0;
      if (dir > 0) {
        if (loop) {
          if (t >= n + CLONE_N - 1) { clearTimeout(flipWrapT); flipWrap(); t = flipT; }
          t += 1;
        } else if (!left && t >= n - 1) {
          t = 0;                                  /* no clones: the theme's own wrap back to the first image */
        } else {
          t += 1;
        }
      } else {
        if (t === 0) {
          if (loop) jump = setWidth();            /* silent, pixel-identical shift into the clone copy of the origin */
          t = n;
        }
        t -= 1;
      }
      left = t === 0;
      flipWrapTries = 0;
      clearTimeout(flipWrapT);
      snapSet(true);
      if (jump > 0) scrollNow(viewer.scrollLeft + jump);
      var target = flipPos(t, left, trackItems());
      if (target === null) return false;
      flipT = t;
      flipLeft = left;
      viewer.scrollTo({ left: target < 0 ? 0 : target, behavior: reduced.matches ? 'auto' : 'smooth' });
      revealThumb(vis[flipIndex(n)]);
      syncGallery();
      return true;
    }

    function flipKey(e) {
      if (!flipOn()) return;
      var fwd = e.key === 'ArrowRight' || e.keyCode === 39;
      var back = e.key === 'ArrowLeft' || e.keyCode === 37;
      if (!fwd && !back) return;
      e.preventDefault();
      flipStep(fwd ? 1 : -1);
    }

    /* clones rebuilt (the media ids and the loop flag are the key), t clamped, the viewer put back on t's position */
    function flipSync(derive) {
      if (!flipCfgOn() || !stripActive()) { clearClones(); cloneKey = ''; return; }
      var vis = visible();
      var n = vis.length;
      if (n < 2) { clearClones(); cloneKey = ''; flipT = 0; flipLeft = true; return; }
      var key = loopOn() ? 'L' : '-';
      for (var i = 0; i < n; i++) key += vis[i].dataset.mediaId + ',';
      if (key !== cloneKey) { buildClones(); cloneKey = key; }
      if (derive) flipT = currentIndex(vis);
      var maxT = flipClones.length ? n : n - 1;
      if (flipT > maxT) flipT = maxT;
      if (flipT < 0) flipT = 0;
      flipLeft = flipT === 0;
      var target = flipPos(flipT, flipLeft, trackItems());
      if (target === null) return;
      snapSet(true);
      scrollNow(target);
      snapSet(false);
      syncGallery();
    }
    function flipDrop() { clearClones(); cloneKey = ''; flipExternal = 1; }
    function flipAfterVariant() {
      setTimeout(function () {
        flipExternal = 0;
        var mg = gallery();
        var vis = visible();
        var i = mg && mg.currentItem ? vis.indexOf(mg.currentItem) : -1;
        if (i >= 0) { flipT = i; flipLeft = i === 0; }
        flipSync(false);
        paintGapBg();
      }, 0);
    }

    /* ask 1: the ground between and around the slots takes the details column's own colour, measured live
       (the packshots keep their --blend-bg-color: only .media-gallery__viewer's background is repainted) */
    function paintGapBg() {
      var s = stripCfg();
      if (!s || s.gapBg !== 'details') { media.style.removeProperty('--umbra-gap-bg'); return; }
      var el = document.querySelector('.product-info') || document.querySelector('.product-details') || document.body;
      var c = '';
      while (el) {
        var bg = getComputedStyle(el).backgroundColor;
        if (bg && bg !== 'transparent' && bg.replace(/ /g, '').indexOf('rgba(0,0,0,0)') < 0) { c = bg; break; }
        el = el.parentElement;
      }
      if (c && media.style.getPropertyValue('--umbra-gap-bg') !== c) media.style.setProperty('--umbra-gap-bg', c);
    }

    /* the end of a strip = the viewer cannot scroll further right (with N slots the last index is never the scroll position) */
    function stripAtEnd() {
      return viewer.scrollLeft + viewer.clientWidth >= viewer.scrollWidth - 1;
    }
    /* filmstrip: the 'auto' slot count for the active tier, re-fitted on resize and on a tier change, and the arrow
       states. Refine round (defect C0.3): while the strip is active BOTH arrows stay live and loop, exactly like a
       wheel notch - the theme disables next on the last index and prev on the first, but with N slots side by side the
       last index is never reached and the strip's own end is not the end of the gallery. The moment the strip stops
       being active (a resize out of the tier, or 'as many as fit' falling to one slot) the theme's own rule is put
       back, so no arrow is ever left dead. 120ms after the viewer settles, because the theme rewrites the buttons on
       scroll and only when the active index changes. */
    var stripT = 0;
    function stripEnd() {
      var prev = media.querySelector('.media-ctrl__btn[name="prev"]');
      var next = media.querySelector('.media-ctrl__btn[name="next"]');
      if (!prev && !next) return;
      if (stripActive()) {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        return;
      }
      var items = visible();
      var idx = currentIndex(items);
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = items.length < 2 || idx >= items.length - 1;
    }
    function stripSoon() {
      /* the theme disables the next arrow the moment its index reaches the last item (assets/media-gallery.js:446),
         which in an active strip happens mid-scroll; re-enable in the SAME scroll event instead of 120ms later, or a
         click that lands in that window is swallowed - a disabled button fires no click at all, so the capture-phase
         handler that loops the strip never runs (measured at 2560: one dead click at the strip end, then the loop). */
      if (stripActive()) stripEnd();
      clearTimeout(stripT);
      stripT = setTimeout(stripEnd, 120);
    }
    var stripFitted = false;
    function refitStrip() {
      var changed = fitStrip(media, viewer);
      /* the first fit re-stamps unconditionally: with 'auto' the section's bootstrap has already set
         data-umbra-strip before this script runs, so 'changed' is false while the fx attribute stamped by the
         init pass above (autoN still 1) is stale */
      if (changed || !stripFitted) {
        stripFitted = true;
        applyFx();
        applyArrows();
        if (changed) pokeGallery();
      }
      stripSoon();
      paintGapBg();
      flipSync(!flipSynced);
      flipSynced = true;
    }
    var flipSynced = false;
    if (cfg.strip || (cfg.lg && cfg.lg.strip)) {
      patchGallery();
      refitStrip();
      listen(window, 'on:debounced-resize', refitStrip);
      listen(document, 'on:variant:change', stripSoon);
      listen(document, 'on:variant:change', flipDrop, true);
      listen(document, 'on:variant:change', flipAfterVariant);
      viewer.addEventListener('scroll', stripSoon, { passive: true });
      viewer.addEventListener('scroll', flipSettle, { passive: true });
      viewer.addEventListener('keydown', flipKey);
      offs.push(clearClones);
      [mq, mqLg].forEach(function (list) {
        if (list.addEventListener) {
          listen(list, 'change', refitStrip);
        } else if (list.addListener) {
          list.addListener(refitStrip);
          offs.push(function () { list.removeListener(refitStrip); });
        }
      });
    }

    function currentIndex(items) {
      var x = viewer.scrollLeft, best = 0, bestD = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    /* vertical rail only: scroll the rail (never the window) so the target's thumbnail is in view */
    function revealThumb(to) {
      if (!to) return;
      var rail = media.querySelector('.media-gallery__thumbs');
      if (!rail || rail.scrollHeight <= rail.clientHeight + 1) return;
      var t = rail.querySelector('[data-media-id="' + to.dataset.mediaId + '"]');
      if (!t) return;
      var gap = parseFloat(getComputedStyle(media).getPropertyValue('--umbra-thumb-gap')) || 12;
      var r = rail.getBoundingClientRect();
      var b = t.getBoundingClientRect();
      var delta = 0;
      if (b.top < r.top + gap) {
        delta = b.top - r.top - gap;
      } else if (b.bottom > r.bottom - gap) {
        delta = b.bottom - r.bottom + gap;
      }
      if (!delta) return;
      rail.scrollBy({ top: delta, behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    function fxOk(from, to) {
      return fx().on && !reduced.matches && !!from && !!to && from !== to &&
        from.dataset.mediaType === 'image' && to.dataset.mediaType === 'image' &&
        !!from.querySelector('.media');
    }

    /* the ghost of the outgoing image over the viewer, the incoming item marked; whoever moves the slider does so separately */
    function ghostSwap(cur, to, dir) {
      var host = viewer.parentElement;
      var seq = ++fxSeq;
      var old = host.querySelectorAll('.umbra-fx-ghost');
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
      var ins = viewer.querySelectorAll('.umbra-fx-in');
      for (var j = 0; j < ins.length; j++) {
        ins[j].classList.remove('umbra-fx-in');
        ins[j].style.removeProperty('--umbra-fx-dir');
      }
      var ghost = document.createElement('div');
      ghost.className = 'umbra-fx-ghost';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.style.setProperty('--umbra-fx-dir', String(dir));
      ghost.appendChild(cur.querySelector('.media').cloneNode(true));
      host.appendChild(ghost);
      to.style.setProperty('--umbra-fx-dir', String(dir));
      to.classList.add('umbra-fx-in');
      to.dataset.umbraFxSeq = String(seq);
      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        if (to.dataset.umbraFxSeq === String(seq)) {
          to.classList.remove('umbra-fx-in');
          to.style.removeProperty('--umbra-fx-dir');
          delete to.dataset.umbraFxSeq;
        }
      }
      ghost.addEventListener('animationend', function (e) {
        if (e.target === ghost) done();
      });
      setTimeout(done, fx().ms + 120);
    }

    function go(items, next, dir) {
      var cur = items[currentIndex(items)];
      var to = items[next];
      if (!to) return;
      if (!fxOk(cur, to)) {
        viewer.scrollTo({ left: to.offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
        revealThumb(to);
        return;
      }
      ghostSwap(cur, to, dir);
      /* the jump is instant under the ghost; the theme's own scroll handler updates thumbs, counter and arrows */
      var sb = viewer.style.scrollBehavior;
      viewer.style.scrollBehavior = 'auto';
      viewer.scrollLeft = to.offsetLeft;
      viewer.style.scrollBehavior = sb;
      revealThumb(to);
    }

    function advance(dir) {
      var items = visible();
      if (items.length < 2) return false;
      /* flip: the wheel notch, the arrow pill, the edge zones, the keyboard and any programmatic move share one step */
      if (flipOn()) return flipStep(dir);
      var cur = currentIndex(items);
      var next = cur + dir;
      var loop = next < 0 || next >= items.length;
      /* filmstrip: forward from the end of the strip loops to the first image (the theme's next arrow is disabled there, so the scrollTo below does the move) */
      if (dir > 0 && !loop && stripActive() && stripAtEnd()) {
        loop = true;
        next = 0;
      }
      if (loop) next = (next + items.length) % items.length;
      lastTarget = next;
      if (fx().on) {
        go(items, next, dir);
        return true;
      }
      var btn = media.querySelector('.media-ctrl__btn[name="' + (dir > 0 ? 'next' : 'prev') + '"]');
      if (!loop && btn && !btn.disabled && !reduced.matches && !stripActive()) {
        btn.click();
        revealThumb(items[next]);
        return true;
      }
      viewer.scrollTo({ left: items[next].offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
      revealThumb(items[next]);
      return true;
    }

    /* arrows (round 2): advance() exposed for the edge-glow / cursor zones, the preview override, and the
       data-umbra-cur-type / progress hairline stamps (see the header comment) */
    media.umbraAdvance = advance;
    if (ARROWS.indexOf(qa) >= 0) {
      media.setAttribute('data-umbra-arrows', qa);
      media.setAttribute('data-umbra-arrows-lg', qa);
    }
    var zones = media.querySelectorAll('.umbra-edge');
    var prog = media.querySelector('.umbra-progress');
    var stampT = 0;
    var stamp = function () {
      var items = visible();
      var idx = currentIndex(items);
      if (items[idx]) media.setAttribute('data-umbra-cur-type', items[idx].dataset.mediaType || 'image');
      if (prog) {
        prog.style.setProperty('--umbra-n', String(items.length || 1));
        prog.style.setProperty('--umbra-i', String(idx));
      }
    };
    var stampSoon = function () {
      clearTimeout(stampT);
      stampT = setTimeout(stamp, 100);
    };
    if (zones.length || prog) {
      Array.prototype.forEach.call(zones, function (z) {
        z.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          advance(z.getAttribute('data-dir') === 'next' ? 1 : -1);
        });
      });
      stamp();
      viewer.addEventListener('scroll', stampSoon, { passive: true });
      listen(window, 'on:debounced-resize', stampSoon);
      listen(document, 'on:variant:change', stampSoon);
    }

    /* the wheel gesture: desktop only (smaller and larger screens), and only while the wheel setting is on */
    media.addEventListener('wheel', function (e) {
      if (!cfg.wheel || !mq.matches || e.ctrlKey) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      /* the thumbnails are their own scroller (horizontal strip or vertical rail): leave a wheel over them alone when they can scroll */
      var rail = e.target && e.target.closest ? e.target.closest('.media-gallery__thumbs') : null;
      if (rail) {
        var strip = rail.querySelector('.media-thumbs');
        if ((strip && strip.scrollWidth > strip.clientWidth + 1) || rail.scrollHeight > rail.clientHeight + 1) return;
      }

      var now = e.timeStamp;
      var gap = now - lastAt;
      var mag = Math.abs(e.deltaY);
      lastAt = now;
      /* a gallery with fewer than two photos cannot move, so it must not take the wheel from the page */
      if (visible().length < 2) return;
      /* R1103: at the end the gesture goes to the page (never prevented), and so does the rest of it */
      if (relEnds()) {
        var rdir = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
        var rfresh = gap >= QUIET_MS;
        if (releasing && !rfresh && (!rdir || rdir === releaseDir)) return;
        releasing = false;
        if (rdir && !(locked && !rfresh && rdir === lockDir) && !pendingDir && atEnd(rdir)) {
          releasing = true;
          releaseDir = rdir;
          accum = 0;
          locked = false;
          return;
        }
      }
      /* every event is prevented once the gallery owns the gesture, or the page creeps while the accumulator fills */
      e.preventDefault();
      if (!mag) return;
      var dir = e.deltaY > 0 ? 1 : -1;
      /* R1102: a gesture ends after QUIET_MS of silence. After a step the rest of that gesture (more notches of a
         spin, a flick, a trackpad's momentum tail) is swallowed; a new gesture, or a turn of direction (a tail never
         reverses), starts counting again. Small trackpad deltas add up to SENS before a step. */
      var fresh = gap >= QUIET_MS;
      if (fresh || dir !== accumDir) { accum = 0; accumDir = dir; }
      if (locked) {
        if (!fresh && dir === lockDir) return;
        locked = false;
      }
      accum += mag;
      if (accum < SENS) return;
      accum = 0;
      locked = true;
      lockDir = dir;
      /* the previous step is still on screen (a glide, or the crossfade): this one waits for it, never stacks on it */
      pendingDir = dir;
      runPending();
    }, { passive: false });
    /* a step is running while its crossfade lasts (fx) and while the viewer is still scrolling (a glide) */
    viewer.addEventListener('scroll', function () { lastScrollAt = performance.now(); }, { passive: true });
    /* R1103: the photo shown, or the one a running glide is heading to, is the last (dir 1) or the first (dir -1) */
    function atEnd(dir) {
      var items = visible();
      var n = items.length;
      if (n < 2) return false;
      if (flipOn()) {
        var fi = flipIndex(n);
        return dir > 0 ? fi === n - 1 : fi === 0;
      }
      if (stripActive()) return dir > 0 ? stripAtEnd() : viewer.scrollLeft <= 1;
      var ci = moving() && lastTarget >= 0 && lastTarget < n ? lastTarget : currentIndex(items);
      return dir > 0 ? ci === n - 1 : ci === 0;
    }
    function moving() {
      var t = performance.now();
      return t < stepEnd || t - lastScrollAt < SCROLL_IDLE_MS;
    }
    function runPending() {
      clearTimeout(pendingT);
      if (!pendingDir) return;
      if (moving()) { pendingT = setTimeout(runPending, 40); return; }
      var d = pendingDir;
      pendingDir = 0;
      /* R1103: with the ends released, a queued wheel step never wraps */
      if (relEnds() && atEnd(d)) return;
      var f = fx();
      stepEnd = performance.now() + (f.on && !reduced.matches ? f.ms : MOVE_MIN_MS);
      advance(d);
    }
    offs.push(function () { clearTimeout(pendingT); });

    /* thumbnail click with fx: capture phase, so the theme's handleThumbClick then finds the slider already there (its instant scrollTo is a no-op) */
    media.addEventListener('click', function (e) {
      if (!fx().on) return;
      var btn = e.target && e.target.closest ? e.target.closest('.media-thumbs__btn') : null;
      if (!btn) return;
      var li = btn.closest('[data-media-id]');
      if (!li) return;
      var items = visible();
      var cur = currentIndex(items);
      var idx = -1;
      for (var i = 0; i < items.length; i++) if (items[i].dataset.mediaId === li.dataset.mediaId) idx = i;
      if (idx < 0 || idx === cur) return;
      go(items, idx, idx > cur ? 1 : -1);
    }, true);

    /* thumbnail click while the flip is on: the theme's jump is start-aligned, so the move is taken over here */
    media.addEventListener('click', function (e) {
      if (!flipOn()) return;
      var tb = e.target && e.target.closest ? e.target.closest('.media-thumbs__btn') : null;
      if (!tb) return;
      var tli = tb.closest('[data-media-id]');
      if (!tli) return;
      var tv = visible();
      for (var ti = 0; ti < tv.length; ti++) {
        if (tv[ti].dataset.mediaId !== tli.dataset.mediaId) continue;
        e.preventDefault();
        e.stopPropagation();
        flipT = ti;
        flipLeft = ti === 0;
        var tp = flipPos(flipT, flipLeft, trackItems());
        if (tp !== null) viewer.scrollTo({ left: tp < 0 ? 0 : tp, behavior: reduced.matches ? 'auto' : 'smooth' });
        syncGallery();
        return;
      }
    }, true);

    /* arrow click with fx: the theme's smooth scrollTo is stopped and go() does the move; no wrap, the ends are left to
       the theme. Refine round (defect C0.3): in an ACTIVE strip the click goes through advance() instead - the same
       path as a wheel notch, so it steps exactly one slot, loops at the ends and is instant under reduced motion. The
       theme's own handler always animates (assets/media-gallery.js:368 scrollTo({ behavior: 'smooth' }), no
       reduced-motion guard anywhere in that file), which left the pill animating ~250ms while the wheel was instant. */
    media.addEventListener('click', function (e) {
      var stripOn = stripActive();
      if (!fx().on && !stripOn) return;
      var arrow = e.target && e.target.closest ? e.target.closest('.media-ctrl__btn[name="prev"], .media-ctrl__btn[name="next"]') : null;
      if (!arrow) return;
      var dir = arrow.getAttribute('name') === 'next' ? 1 : -1;
      if (stripOn) {
        e.preventDefault();
        e.stopPropagation();
        advance(dir);
        return;
      }
      var items = visible();
      var cur = currentIndex(items);
      var next = cur + dir;
      if (next < 0 || next >= items.length) return;
      e.preventDefault();
      e.stopPropagation();
      go(items, next, dir);
    }, true);

    /* phone dot tap with fx (the section's dots script does the plain smooth scroll otherwise): capture phase, its own smooth scrollTo then lands on an already-moved slider; the counter pill (over nine images) steps forward and loops */
    media.addEventListener('click', function (e) {
      if (!fx().on) return;
      var li = e.target && e.target.closest ? e.target.closest('.pdp-mdots li') : null;
      if (!li) return;
      var ul = li.parentNode;
      var items = visible();
      if (items.length < 2) return;
      var cur = currentIndex(items);
      var idx = ul.classList.contains('pdp-mdots--count') ? (cur + 1) % items.length : Array.prototype.indexOf.call(ul.children, li);
      if (idx < 0 || idx === cur || !items[idx]) return;
      go(items, idx, idx > cur ? 1 : -1);
    }, true);

    /* colour swatch change with fx: ghost only, taken BEFORE the theme's onVariantChange (bubble phase) hides the
       outgoing item through media grouping and jumps instantly; scrollLeft is never written here */
    listen(document, 'on:variant:change', function (e) {
      if (!fx().on) return;
      var fm = e.detail && e.detail.variant && e.detail.variant.featured_media;
      if (!fm) return;
      var to = viewer.querySelector('[data-media-id="' + fm.id + '"]');
      var items = visible();
      var cur = items[currentIndex(items)];
      if (!to || !fxOk(cur, to)) return;
      var dir = (cur.compareDocumentPosition(to) & 4) ? 1 : -1;
      ghostSwap(cur, to, dir);
    }, true);
  }

  function init() {
    if (cfg.wheel) watchHeaderEnd();
    Array.prototype.forEach.call(document.querySelectorAll('#product-media'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (e) {
    var list = e.target && e.target.querySelectorAll ? e.target.querySelectorAll('#product-media') : [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].umbraTeardown) list[i].umbraTeardown();
    }
  });
})();
